export const themes = {
    incred: {
        primary: "#F15424",
        secondary: "#283A97",
    },
    oro: {
        primary: "#25D782",
        secondary: "#2E3092"
    }
}